import script from "./SingleTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleTransfer.vue?vue&type=script&setup=true&lang=js"

import "./SingleTransfer.vue?vue&type=style&index=0&id=a535d502&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a535d502"]])

export default __exports__